/* wsapi3-apps v1.0 */
/* Deploy Version 2026-10-12 09:43:28 */
/* Deploy Version 2026-09-24 19:11:08 */
/* Registro de "apps nativos substituídos pelo tema". Precisa carregar com
   etapa:"*" e ANTES do bloco de apps da API dentro do GERAL.js — a ordem de
   concatenação em local-layout.service.ts (buildAndWriteAssets) garante isso:
   módulos padrão (passo 1) entram no array antes dos apps vindos de
   /store/layout/apps (passo 2), mesmo grupo GERAL, mesmo <script>, então isso
   aqui já roda antes do app nativo checar a flag.

   Cada chave diz "o tema já reimplementou esse app, não execute a versão
   nativa". O app nativo (mantido no banco/plataforma) precisa checar essa
   flag antes de rodar sua própria lógica. */
window.WsApi3Apps = window.WsApi3Apps || {};
window.WsApi3Apps.freteGratis = true;

/* Só a parte do ProductRecomend (app "suggestion-slider") que tenta injetar
   no cart-drawer — a parte que injeta na página /carrinho (etapasObj.carrinho)
   continua nativa, não temos substituto pra ela ainda (ver Fase 1 do redesign
   do checkout-cart). Flag específica, não a mesma chave genérica, porque o
   app nativo é usado em dois contextos e só um foi substituído. */
window.WsApi3Apps.productRecomendDrawer = true;

/* ===========================================
   MODULE: CHECKOUT SUGGESTION SLIDER (07/08/26)
   Reimplementação local do "Aproveite e leve também" (recomendados) só na
   página /carrinho — o drawer já é coberto pelo flag productRecomendDrawer
   acima + wsapi3-cart-drawer-rules._renderSuggestions().

   Detecção: o app nativo passa a expor `let wsAppRecomend = true;` no script
   injetado quando o app está ativo na loja. Isso só diz SE devemos renderizar
   — não existe (ainda) flag nativo equivalente ao productRecomendDrawer pra
   suprimir o /carrinho do lado nativo.

   NEUTRALIZAÇÃO do app nativo (a única forma confiável de evitar duplicação):
   o create() nativo (etapasObj.carrinho) faz
   `document.querySelectorAll("[cart-suggestion-slider]")` e reescreve
   incondicionalmente TODO elemento com esse atributo — inclusive o que a
   gente já criou — sem checar quem o criou. A checagem de idempotência dele
   (`!existAncor.querySelector("[cart-suggestion-slider]")`) só evita criar um
   SEGUNDO elemento, não impede o create() de sobrescrever o conteúdo do que
   já existe. Como o get() nativo primeiro faz
   `await ApiWS.Calls.listProducts.suggestion()` (uma chamada de API), nosso
   slider nascia certo e, ~1s depois — quando essa promise nativa resolvia —
   era reescrito com o layout dele (perView 3.4). Só ganhar a corrida de
   criação da âncora não resolve; por isso interceptamos wsMain.createModule
   e neutralizamos os métodos do módulo nativo "suggestion-slider" assim que
   ele tenta se registrar (this.modules[obj.name] = obj não tem nenhuma
   proteção contra nome duplicado/patch). */
/* setTimeout(fn, 0) em vez de IIFE imediata: "wsMain" (const wsMain = new
   wsMainjs()) só é instanciado mais adiante no mesmo bundle concatenado
   (GERAL.js) — acessar wsMain de forma síncrona aqui no topo do arquivo
   estoura "Cannot access 'wsMain' before initialization" (TDZ) e trava a
   aplicação inteira. Um setTimeout(0) roda só depois que todo o script
   síncrono (incluindo a instanciação do wsMain) já terminou — e ainda assim
   bem antes do setTimeout(..., 3000) nativo. */
/* Lista de módulos nativos totalmente substituídos, sem flag equivalente à
   freteGratis/productRecomendDrawer do lado nativo — a única forma confiável
   de neutralizar é interceptar o registro em wsMain.createModule.

   - "suggestion-slider": ver bloco CHECKOUT SUGGESTION SLIDER acima.
   - "advanced-search" (18/09/26): app nativo "AdvancedSearch" (ver
     bug-advancedsearch-app-https-localhost na memória do projeto). A
     reimplementação local mora no bloco MODULE: ADVANCED SEARCH LOCAL mais
     abaixo, registrada sob o nome "wsapi3-search-local" (mesmo mecanismo do
     "checkout-suggestion" acima, que também não reusa o nome nativo). */
setTimeout(function () {
    if (wsMain.__nativeModulesPatched) return;
    wsMain.__nativeModulesPatched = true;
    const NATIVE_MODULES_TO_NEUTRALIZE = ["suggestion-slider", "advanced-search"];
    const originalCreateModule = wsMain.createModule.bind(wsMain);
    wsMain.createModule = function (obj) {
        if (obj && NATIVE_MODULES_TO_NEUTRALIZE.includes(obj.name)) {
            const noop = () => false;
            ["get", "create", "update", "clear", "watching"].forEach(fn => {
                if (typeof obj[fn] === "function") obj[fn] = noop;
            });
        }
        return originalCreateModule(obj);
    };
}, 0);

var WS_SUGGESTION_SLIDER_DEBUG = false;
function wsSuggestionLog() {
    if (!WS_SUGGESTION_SLIDER_DEBUG) return;
    try { console.log.apply(console, arguments); } catch (_) { }
}

function wsSuggestionAfterBuy() {
    ApiWS.Calls.cartView().then(function (fresh) {
        if (fresh && fresh.products !== undefined) {
            window.cartJson = fresh;
            try { wsMain.modules['checkout-cart2'].create(fresh); } catch (e) { }
        }
    }).catch(function (e) { console.error('[checkout-suggestion] afterBuy:', e); });
}

setTimeout(function () {
    wsMain.createModule({
        name: "checkout-suggestion",
        function: "get",

        subFunctions: {
            waitForNativeFlag(attempt) {
                attempt = attempt || 0;
                return new Promise(resolve => {
                    if (typeof wsAppRecomend !== 'undefined') { resolve(!!wsAppRecomend); return; }
                    if (attempt >= 6) { resolve(false); return; }
                    setTimeout(() => {
                        wsMain.modules["checkout-suggestion"].subFunctions.waitForNativeFlag(attempt + 1).then(resolve);
                    }, 500);
                });
            },

            createAncor() {
                const holder = document.querySelector('#ws-carrinhoNovo [ws-cart-app="app-suggestion"]');
                if (!holder) return null;
                // Checa os dois atributos: o nosso (ws-suggestion-slider) e o nativo
                // (cart-suggestion-slider, só por segurança — o JS nativo já está
                // neutralizado via patch em wsMain.createModule, mas não custa nada
                // continuar defensivo aqui).
                if (holder.querySelector('[ws-suggestion-slider], [cart-suggestion-slider]')) return null;

                const targetType = window.innerWidth < 1000 ? "checkoutMobile" : "checkout";
                // Atributo próprio (NÃO "cart-suggestion-slider") de propósito: esse é
                // o nome que o app nativo usa, e o CSS injetado por ele (separado do
                // JS, que já neutralizamos) também estiliza esse seletor — inclusive
                // com um padding vertical de 5rem que ficava vazando pro nosso card
                // por causa da cascata (mesma especificidade, CSS nativo concatenado
                // depois do nosso). Usando um atributo só nosso, nenhuma regra CSS
                // nativa consegue mais alcançar esse elemento.
                const slider = wsMain.tools.createElm({ type: "div", attrs: { "ws-suggestion-slider": targetType } });
                holder.append(slider);
                return slider;
            },

            createProds(prod) {
                const shopId = document.querySelector('#HD_LV_ID')?.value || '';
                const buttonLink = `javascript:void(wsFuncBtBuyOnList('${shopId}', '${prod.id}', 'wsSuggestionAfterBuy()'))`;

                const prodPrice = prod?.precos?.preco_promocao
                    ? wsMain.data.treatPrice(prod.precos.preco_promocao)
                    : wsMain.data.treatPrice(prod.precos.preco);

                let prodImage = `<img src="/lojas/img/sem-foto.jpg" alt="Produto sem foto" width="600" height="600" loading="lazy">`;
                let prodClass = `suggestion__image-link whithout-image`;
                if (prod.fotos && prod.fotos.length) {
                    prodClass = `suggestion__image-link`;
                    prodImage = `<img src="${prod.fotos[0]}" alt="${(prod.nome || '').replace(/"/g, '&quot;')}">`;
                }

                return wsMain.tools.createElm({
                    type: "div",
                    attrs: { class: "suggestion-prod" },
                    innerHTML: `
                        <div class="suggestion__image-container">
                            <a class="${prodClass}" href="${prod.links?.ver_produto || '#'}">${prodImage}</a>
                        </div>
                        <div class="suggestion__infos-container">
                            <p class="infos-container__name">${prod.nome}</p>
                            <p class="infos-container__price">${prodPrice}</p>
                            <a class="suggestion__btn" href="${buttonLink}">Adicionar</a>
                        </div>`,
                });
            },
        },

        getCartSig() {
            const cart = window.cartJson;
            return cart ? `${Array.isArray(cart.products) ? cart.products.length : 0}|${cart.total || ''}` : '';
        },

        async get() {
            try {
                if (!document.querySelector('#ws-carrinhoNovo [ws-cart-app="app-suggestion"]')) return false;

                const enabled = await wsMain.modules["checkout-suggestion"].subFunctions.waitForNativeFlag();
                wsSuggestionLog("[checkout-suggestion] get() | wsAppRecomend habilitado:", enabled);
                if (!enabled) return false;

                const anchor = wsMain.modules["checkout-suggestion"].subFunctions.createAncor();
                if (!anchor) return false; // já existe uma âncora (nossa ou nativa) — não duplica

                const prodsArr = await ApiWS.Calls.listProducts.suggestion();
                if (!Array.isArray(prodsArr) || !prodsArr.length) { anchor.remove(); return false; }

                wsMain.modules["checkout-suggestion"].create(anchor, prodsArr);
                // Semeia com a assinatura ATUAL do carrinho — sem isso, o primeiro
                // tick do watching() sempre bate diferente de "" e força um
                // re-render ~1,5s depois mesmo sem nenhuma mudança real no carrinho
                // (causava o "renderiza de um jeito e troca sozinho" reportado).
                wsMain.modules["checkout-suggestion"].watching(anchor, wsMain.modules["checkout-suggestion"].getCartSig());
                return true;
            } catch (error) { wsSuggestionLog("[checkout-suggestion] get() | error:", error); return false; }
        },

        create(anchor, prodsArr) {
            try {
                anchor.innerHTML = "";
                anchor.append(wsMain.tools.createElm({ type: "div", attrs: { class: "container" } }));
                const container = anchor.querySelector(".container");
                container.append(
                    wsMain.tools.createElm({ type: "div", attrs: { class: "suggestion__title" }, innerHTML: `<h2>Aproveite e leve também</h2>` }),
                    wsMain.tools.createElm({ type: "div", attrs: { class: "suggestion__sliderProds" } })
                );

                const sliderContainer = anchor.querySelector(".suggestion__sliderProds");
                const targetType = anchor.getAttribute("ws-suggestion-slider");
                const perView = prodsArr.length <= 2 ? 2 : 2.5;
                const dataWsjsSlide = targetType === "checkoutMobile"
                    ? `slides.perView:1.5;slides.spacing:12;dots:false;arrows:false;loop:false;dotsType:group;`
                    : `slides.perView:${perView};slides.spacing:20;dots:false;loop:false;dotsType:group;`;
                anchor.setAttribute("data-wsjs-slide", dataWsjsSlide);

                prodsArr.forEach(prod => {
                    const elm = wsMain.modules["checkout-suggestion"].subFunctions.createProds(prod);
                    if (elm) sliderContainer.append(elm);
                });

                const sliderOptions = wsMain.tools.getWsData(anchor, "slide");
                const [sliderVrf, slider] = wsMain.tools.createSlide(sliderContainer, sliderOptions);
                if (sliderVrf) slider.update();

                return true;
            } catch (error) { wsSuggestionLog("[checkout-suggestion] create() | error:", error); return false; }
        },

        async watching(anchor, lastSig) {
            try {
                await new Promise(r => setTimeout(r, 1500));
                if (!anchor?.isConnected) return; // âncora removida (ex: navegou pra outra página)

                const sig = wsMain.modules["checkout-suggestion"].getCartSig();

                if (sig && sig !== lastSig) {
                    const prodsArr = await ApiWS.Calls.listProducts.suggestion();
                    if (Array.isArray(prodsArr) && prodsArr.length) {
                        wsMain.modules["checkout-suggestion"].create(anchor, prodsArr);
                    } else if (Array.isArray(prodsArr)) {
                        anchor.innerHTML = "";
                    }
                }

                wsMain.modules["checkout-suggestion"].watching(anchor, sig || lastSig);
            } catch (error) { wsSuggestionLog("[checkout-suggestion] watching() | error:", error); }
        },
    });

    wsMain.modules["checkout-suggestion"].get();
}, 3000);

/* ===========================================
   MODULE: ADVANCED SEARCH LOCAL (18/09/26)
   Passo 2 da migração da busca avançada pra dentro deste módulo (passo 1 foi
   a neutralização do app nativo "advanced-search", ver
   NATIVE_MODULES_TO_NEUTRALIZE acima). Porta o comportamento do app nativo
   quase 1:1 — ele funciona bem no desktop, só a responsividade mobile do
   painel de resultados que é ruim (cards verticais/scroll horizontal ilegíveis
   numa tela estreita, ver bug-advancedsearch-app-https-localhost na memória
   do projeto pra mais contexto sobre esse app).

   CSS totalmente internalizado em wsapi3-apps.css (mesma pasta), GLOBAL pra
   qualquer tema com este módulo — não é fix de uma loja só. Todo o HTML
   gerado aqui usa um namespace PRÓPRIO ("wsapi3-search-*", ids "#wsapi3-search-*")
   em vez de reaproveitar as classes do app nativo ("advanced-search-*",
   "recognition-btn", "product-sugestion__image-container" etc.) de propósito:
   como as duas lojas de CSS (a nossa, deste default-module, e a do app
   nativo, appsData.css — só sai do bundle quando a Webstore desabilitar o
   app pro store) convivem no mesmo <style> por um tempo, nomes diferentes
   significam ZERO briga de especificidade/ordem entre elas — nenhuma
   precisa de !important ou depender de quem carrega depois. Bônus: o CSS
   nativo tem um bug onde .advanced-search-prods-title lê a CSS var
   --prods-title-line-clamp, mas quem seta é --advanced-search-prods-title-line-clamp
   (nomes diferentes, var nunca aplicada) — no namespace novo isso já nasce
   consistente (--wsapi3-search-prods-title-line-clamp, setada e lida com o
   mesmo nome). Quando a Webstore finalmente desligar o app nativo pra essa
   loja (migração pra nova tecnologia), esse módulo continua funcionando
   sozinho sem precisar de nenhum ajuste.

   Nome do módulo é "wsapi3-search-local" (não "advanced-search") de
   propósito, mesmo padrão do "checkout-suggestion" acima — evita qualquer
   corrida com o registro nativo (já neutralizado, mas os métodos noop ainda
   ocupam a chave "advanced-search" em wsMain.modules).

   Detalhe entre scripts que não precisa de nenhuma ação nossa: o bundle nativo
   declara `var searchAdvanced = true;` no top-level do próprio app (fora do
   createModule, portanto NÃO neutralizado pelo nosso patch) — é isso que faz
   o core do wsMain pular o fallback de busca básica (`BuscaInicializa`) mais
   acima no mesmo bundle. Como esse app nativo continua presente/concatenado
   (só o createModule dele é neutralizado), essa flag já é setada
   automaticamente antes mesmo do nosso setTimeout abaixo rodar. */
setTimeout(function () {
    try {
        wsMain.createModule({
            name: "wsapi3-search-local",
            function: "get",
            wsjsOptions: {
                limitToScroll: 8,
                blur: false,
                "wsapi3-search-suspension-points": true,
                prodsTitleLimits: 3,
                maxProds: 10,
                mobileSuggestion: 5,
                autocomplete: true,
                busca_com_voz: true,
                produtos: true,
                sugestoes: true,
                mais_buscados: [],
            },
            subfunctions: {
                actualInputWord: "",
                actualData: "",
                actualFetchedProducts: {},
                lastFetchedProd: [],
                lastFetchedWord: "",
                actualFetchedSuggestions: [],
                wordToViewAll: "",
                storeID: "",
                secondsToSearch: 1500,
                currentIndex: -1,
                suggestionsRequestId: 0,

                createResultsDiv() {
                    const sugestoesExist = wsMain.modules["wsapi3-search-local"].wsjsOptions.sugestoes;
                    const produtosExist = wsMain.modules["wsapi3-search-local"].wsjsOptions.produtos;

                    const resultsDiv = document.createElement("div");
                    resultsDiv.id = "wsapi3-search-results";
                    resultsDiv.setAttribute("wsapi3-search-type", "default");
                    resultsDiv.setAttribute("wsapi3-search-show-suggestions", sugestoesExist);
                    resultsDiv.setAttribute("wsapi3-search-show-products", produtosExist);

                    document.body.appendChild(resultsDiv);
                    return resultsDiv;
                },

                showResultsDiv(div, content = "", title = "", attr = "") {
                    div.style.display = "flex";
                    if (attr) div.setAttribute("wsapi3-search-type", attr);
                    div.innerHTML = title ? `<h2>${title}</h2>${content}` : content;
                    wsMain.modules["wsapi3-search-local"].subfunctions.fitResultsToVisualViewport();
                },

                hideResultsDiv(div) {
                    div.innerHTML = "";
                    div.style.display = "none";
                },

                // Único caminho de "executar a busca" (Enter e clique na lupa). O onclick/
                // onkeydown inline do topo.html chamam FuncaoBuscaBotao(), função da v2 que
                // não existe mais no bundle v3 — sem isso a lupa não fazia nada.
                submitSearch(input) {
                    const term = input.value.trim();
                    if (!term) return;

                    wsMain.modules["wsapi3-search-local"].subfunctions.saveSearchTerm(term);
                    const wordToRedirect = wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(term);
                    if (!wordToRedirect) return;
                    window.location.href = `/busca?s=${wordToRedirect}`;
                },

                // Mobile: ajusta o painel ao "visual viewport" (a área realmente visível —
                // já descontando o zoom que o navegador aplica ao focar o input e o teclado
                // virtual). 100vh/60vh e left/right do CSS são relativos ao layout viewport,
                // que não muda com zoom/teclado — daí o painel cortado. Aqui:
                // - altura máx = espaço entre o topo do painel e o fim da área visível;
                // - com zoom ativo (scale > 1), left/width em px do visual viewport, via
                //   inline !important (único jeito de vencer o inline que positionCloseBtn seta).
                fitResultsToVisualViewport() {
                    const results = document.getElementById("wsapi3-search-results");
                    const vv = window.visualViewport;
                    if (!results || !vv) return;

                    if (window.innerWidth > 800 || results.style.display === "none") {
                        results.style.removeProperty("--wsapi3-search-max-height");
                        return;
                    }

                    const rect = results.getBoundingClientRect();
                    const available = vv.height - (rect.top - vv.offsetTop) - 10;
                    results.style.setProperty("--wsapi3-search-max-height", `${Math.max(available, 120)}px`);

                    if (vv.scale > 1.01) {
                        const leftBase = getComputedStyle(results).position === "fixed" ? vv.offsetLeft : vv.pageLeft;
                        results.style.setProperty("left", `${leftBase + 10}px`, "important");
                        results.style.setProperty("right", "auto", "important");
                        results.style.setProperty("width", `${vv.width - 20}px`, "important");
                        results.dataset.wsapi3VvFit = "1";
                    } else if (results.dataset.wsapi3VvFit) {
                        results.style.removeProperty("left");
                        results.style.removeProperty("right");
                        results.style.removeProperty("width");
                        delete results.dataset.wsapi3VvFit;
                    }
                },

                getSearchHistory() {
                    const history = localStorage.getItem("searchHistory");
                    return history ? JSON.parse(history) : [];
                },

                saveSearchTerm(term) {
                    const history = wsMain.modules["wsapi3-search-local"].subfunctions.getSearchHistory();
                    if (term && !history.includes(term)) {
                        history.unshift(term);
                        if (history.length > 5) history.pop();
                        localStorage.setItem("searchHistory", JSON.stringify(history));
                    }
                },

                configureClearButton(input, clearButton) {
                    input.addEventListener("input", () => {
                        clearButton.style.display = input.value.length > 0 ? "flex" : "none";
                    });

                    clearButton.addEventListener("click", () => {
                        wsMain.modules["wsapi3-search-local"].subfunctions.actualFetchedSuggestions = [];
                        input.value = "";
                        clearButton.style.display = "none";
                        input.focus();
                    });
                },

                displaySearchHistoryAndMostSearched(input, div) {
                    const history = wsMain.modules["wsapi3-search-local"].subfunctions.getSearchHistory();
                    const mostSearched = wsMain.modules["wsapi3-search-local"].wsjsOptions.mais_buscados;
                    if (history.length === 0 && mostSearched.length === 0) return;

                    const suspensionPoints = wsMain.modules["wsapi3-search-local"].wsjsOptions["wsapi3-search-suspension-points"];

                    let historyHtml = "";
                    if (history.length > 0) {
                        historyHtml = '<p class="wsapi3-search-title">Pesquisas recentes</p>';
                        historyHtml += history
                            .map(
                                (item) => `<a
                href="/busca?s=${wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(item)}"
                title="Sugestão de pesquisa"
                class="wsapi3-search-suggestion"
                wsapi3-search-suspension-points="${suspensionPoints}">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                    <path id="Caminho_9585" data-name="Caminho 9585" d="M1972,5716v6l4,2m6-2a10,10,0,1,1-10-10A10,10,0,0,1,1982,5722Z" transform="translate(-1961 -5711)" fill="none" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                </span>
                ${item.trim()}</a>`
                            )
                            .join("");
                    }

                    if (mostSearched.length > 0) {
                        let mostSearchedHtml = '<p class="wsapi3-search-title">Mais procurados</p>';
                        mostSearchedHtml += mostSearched
                            .map(
                                (item) => `<a
                  href="/busca?s=${wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(item)}"
                  class="wsapi3-search-suggestion">
                  <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                    <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                  </svg>
                  ${item}</a>`
                            )
                            .join("");
                        historyHtml += mostSearchedHtml;
                    }

                    wsMain.modules["wsapi3-search-local"].subfunctions.showResultsDiv(div, historyHtml, "", "historySearch");
                    wsMain.modules["wsapi3-search-local"].subfunctions.configureClickNavigation(input, div);
                },

                shouldFetchMostSearched() {
                    const lastFetched = localStorage.getItem("lastFetchedMostSearched");
                    if (!lastFetched) return true;

                    const diffInHours = (new Date() - new Date(lastFetched)) / (1000 * 60 * 60);
                    return diffInHours >= 24;
                },

                saveMostSearched(mostSearched) {
                    localStorage.setItem("mostSearched", JSON.stringify(mostSearched));
                    localStorage.setItem("lastFetchedMostSearched", new Date().toISOString());
                },

                getMostSearched() {
                    const mostSearched = localStorage.getItem("mostSearched");
                    return mostSearched ? JSON.parse(mostSearched) : [];
                },

                showLoading(resultsDiv, mainContainer = false) {
                    const loadingDiv = `<div class="wsapi3-search-loading-products-container">
                <div class="wsapi3-search-loading-products"></div>
            </div>`;

                    if (mainContainer) {
                        const minHeight = resultsDiv.offsetHeight;
                        resultsDiv.style.minHeight = `${minHeight}px`;
                        resultsDiv.innerHTML = loadingDiv;
                        return;
                    }

                    resultsDiv.querySelector(".wsapi3-search-products-container").innerHTML = loadingDiv;
                },

                hideLoading(resultsDiv) {
                    const loadingDiv = resultsDiv.querySelector(".wsapi3-search-loading-products");
                    if (loadingDiv) loadingDiv.remove();
                },

                displayProducts(products, productsToScroll = 2) {
                    if (!products || products.length === 0) {
                        return '<p class="wsapi3-search-no-products">Nenhum produto encontrado...</p>';
                    }

                    const maxProds = wsMain.modules["wsapi3-search-local"].wsjsOptions.maxProds;
                    const productsScroll = maxProds > productsToScroll ? "on" : "off";

                    return `
            <div class="wsapi3-search-products" wsapi3-search-products-scroll="${productsScroll}">
              ${products
                                .map((product, idx) => {
                                    if (idx >= maxProds) return "";

                                    return `<div class="wsapi3-search-product">
                  <a class="wsapi3-search-product-overlay" href="${product.url}"></a>
                  <div class="wsapi3-search-product-image">
                    <img src="${product.photo}" alt="${product.name}">
                  </div>
                  <p class="wsapi3-search-prods-title">${product.name}</p>
                </div>`;
                                })
                                .join("")}
            </div>`;
                },

                addHoverListenersToSuggestions(resultsDiv) {
                    const suggestions = resultsDiv.querySelectorAll(".wsapi3-search-suggestion");
                    const secondsToSearch = wsMain.modules["wsapi3-search-local"].subfunctions.secondsToSearch;

                    suggestions.forEach((suggestion, idx) => {
                        let hoverTimeout;
                        let loadingTimeout;

                        suggestion.addEventListener("mouseenter", () => {
                            const query = suggestion.textContent.trim();
                            const input = document.getElementById("input-busca");
                            wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex = idx;

                            wsMain.modules["wsapi3-search-local"].subfunctions.updateSuggestionHighlight(
                                suggestions,
                                wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex,
                                input
                            );

                            if (wsMain.modules["wsapi3-search-local"].subfunctions.actualFetchedProducts[query]) {
                                const productsContainer = resultsDiv.querySelector(".wsapi3-search-products-container");
                                if (productsContainer) {
                                    productsContainer.innerHTML =
                                        wsMain.modules["wsapi3-search-local"].subfunctions.actualFetchedProducts[query];
                                }
                                return;
                            }

                            loadingTimeout = setTimeout(() => {
                                wsMain.modules["wsapi3-search-local"].subfunctions.showLoading(resultsDiv);
                            }, 300);

                            hoverTimeout = setTimeout(() => {
                                wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex = idx;
                                wsMain.modules["wsapi3-search-local"].subfunctions.updateSuggestionHighlight(
                                    suggestions,
                                    wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex,
                                    input
                                );
                                wsMain.modules["wsapi3-search-local"].subfunctions.fetchProducts(query, resultsDiv);
                            }, secondsToSearch);
                        });

                        suggestion.addEventListener("mouseleave", () => {
                            clearTimeout(hoverTimeout);
                            clearTimeout(loadingTimeout);

                            const lastFetchedProd = wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedProd;
                            const lastFetchedWord = wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedWord;

                            if (lastFetchedProd.length > 0 && lastFetchedWord && wsMain.modules["wsapi3-search-local"].wsjsOptions.produtos) {
                                const productsContainer = resultsDiv.querySelector(".wsapi3-search-products-container");
                                if (productsContainer) {
                                    productsContainer.innerHTML = lastFetchedProd[0][lastFetchedWord];
                                }
                            }
                        });
                    });
                },

                normalizeQuery(query) {
                    if (typeof query !== "string") return;

                    return query
                        .trim()
                        .toLowerCase()
                        .normalize("NFD")
                        .replace(/[̀-ͯ]/g, "")
                        .replace(/[^a-z0-9\s-]/g, "")
                        .replace(/\s+/g, " ");
                },

                viewAllResultsLink(query) {
                    return `<a href="/busca?s=${query}"
          class="wsapi3-search-view-all"
          title="Resultados da busca">Ver todos os resultados</a>`;
                },

                autocompleteInput(input, suggestions, resultsDiv) {
                    if (!wsMain.modules["wsapi3-search-local"].wsjsOptions.autocomplete) return;

                    const currentValue = input.value.trim().toLowerCase();
                    const words = currentValue.split(" ");
                    const lastWord = words[words.length - 1];
                    if (!lastWord) return;

                    for (const suggestion of suggestions) {
                        const match = suggestion.search
                            .toLowerCase()
                            .split(" ")
                            .find((word) => word.startsWith(lastWord));

                        if (match) {
                            const autocompleteText = match.slice(lastWord.length);
                            words[words.length - 1] = lastWord + autocompleteText;
                            input.value = words.join(" ");
                            input.setSelectionRange(currentValue.length, input.value.length);
                            wsMain.modules["wsapi3-search-local"].subfunctions.actualInputWord = input.value;
                            break;
                        }
                    }

                    const suggestionsDiv = resultsDiv.querySelector(
                        ".wsapi3-search-suggestions-container .wsapi3-search-suggestions-options"
                    );
                    suggestionsDiv.setAttribute("autocomplete-inserted", "true");
                },

                // Fallback de host pra "flach.dev.br" em dev local (esse endpoint legado
                // — cadastroAJAX/buscaAjax.aspx — não existe neste Node app, só num
                // domínio real da Webstore; nem "localhost:3000" nem o override
                // "{storeId}(-{layId}).localhost:3000" teriam como responder).
                // Detecção por hostname (não host === "localhost:3000" literal) pra também
                // cobrir o subdomain override (DomainService.resolveSubdomainOverride) —
                // era só o caso exato "localhost:3000" antes, então em qualquer override
                // tipo "29701-159290904.localhost:3000" o fallback nunca disparava e caía
                // no https:// contra um host que não existe (ERR_CONNECTION_RESET).
                // Protocolo http:// só nesse fallback (ver bug-advancedsearch-app-https-localhost
                // na memória do projeto pro histórico) — era sempre https:// no app nativo;
                // em produção o host real continua https://.
                buildSearchAjaxUrl(query) {
                    const lvID = wsMain.modules["wsapi3-search-local"].subfunctions.storeID;
                    const hostname = window.location.hostname;
                    const isLocalDev = hostname === "localhost" || hostname.endsWith(".localhost");

                    let host = window.location.host;
                    let protocol = "https:";
                    if (isLocalDev) {
                        host = "flach.dev.br";
                        protocol = "http:";
                    }
                    return `${protocol}//${host}/cadastroAJAX/buscaAjax.aspx?tipo=busca&LV_ID=${lvID}&version=json&valor=${encodeURIComponent(query)}`;
                },

                async fetchAndSaveMostSearched() {
                    const url = wsMain.modules["wsapi3-search-local"].subfunctions.buildSearchAjaxUrl("");

                    try {
                        const response = await fetch(url);
                        if (!response.ok) {
                            console.error("Error fetching most searched terms");
                            return [];
                        }

                        const data = await response.json();
                        const mostSearched = data.most_searched || [];
                        wsMain.modules["wsapi3-search-local"].subfunctions.saveMostSearched(mostSearched);
                        return mostSearched;
                    } catch (error) {
                        console.error("Error fetching most searched terms:", error);
                        return [];
                    }
                },

                async fetchProducts(query, resultsDiv) {
                    wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedProd.length = 0;
                    wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedWord = "";

                    if (!wsMain.modules["wsapi3-search-local"].wsjsOptions.produtos) return;

                    const normalizedQuery = wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(query);
                    const url = wsMain.modules["wsapi3-search-local"].subfunctions.buildSearchAjaxUrl(normalizedQuery);

                    try {
                        const response = await fetch(url);
                        if (!response.ok) {
                            console.error("Error fetching products");
                            return;
                        }

                        wsMain.modules["wsapi3-search-local"].subfunctions.wordToViewAll = normalizedQuery;

                        const data = await response.json();
                        const productsHtml =
                            wsMain.modules["wsapi3-search-local"].subfunctions.displayProducts(data.products) +
                            wsMain.modules["wsapi3-search-local"].subfunctions.viewAllResultsLink(
                                wsMain.modules["wsapi3-search-local"].subfunctions.wordToViewAll
                            );

                        const productsContainer = resultsDiv.querySelector(".wsapi3-search-products-container");
                        if (productsContainer) productsContainer.innerHTML = productsHtml;

                        if (productsHtml && query) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedProd.push({ [query]: productsHtml });
                            wsMain.modules["wsapi3-search-local"].subfunctions.actualFetchedProducts[query] = productsHtml;
                            wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedWord = query;
                        }
                    } catch (error) {
                        wsMain.modules["wsapi3-search-local"].subfunctions.hideLoading(resultsDiv);
                        console.error("Error fetching products:", error);
                    }
                },

                async fetchSuggestions(input, resultsDiv, query, force = false) {
                    wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedProd.length = 0;
                    wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedWord = "";

                    const sugestoesExist = wsMain.modules["wsapi3-search-local"].wsjsOptions.sugestoes;
                    const produtosExist = wsMain.modules["wsapi3-search-local"].wsjsOptions.produtos;
                    if (!sugestoesExist && !produtosExist) return;

                    const normalizedQuery = wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(query);
                    const url = wsMain.modules["wsapi3-search-local"].subfunctions.buildSearchAjaxUrl(normalizedQuery);

                    // Descarta resposta velha: com o usuário digitando, duas buscas podem estar
                    // em voo — a que responde por último não pode sobrescrever a mais recente.
                    const requestId = ++wsMain.modules["wsapi3-search-local"].subfunctions.suggestionsRequestId;

                    try {
                        let data = "";
                        if (force) {
                            data = wsMain.modules["wsapi3-search-local"].subfunctions.actualData;
                        } else {
                            const response = await fetch(url);
                            if (requestId !== wsMain.modules["wsapi3-search-local"].subfunctions.suggestionsRequestId) return;
                            if (!response.ok) {
                                wsMain.modules["wsapi3-search-local"].subfunctions.showResultsDiv(
                                    resultsDiv,
                                    "<p>Erro ao buscar sugestões...</p>",
                                    "",
                                    "suggestionSearchError"
                                );
                                return;
                            }
                            data = await response.json();
                            if (requestId !== wsMain.modules["wsapi3-search-local"].subfunctions.suggestionsRequestId) return;
                        }

                        wsMain.modules["wsapi3-search-local"].subfunctions.actualData = data;
                        wsMain.modules["wsapi3-search-local"].subfunctions.actualInputWord = query;

                        const { suggestions, products } = data;

                        const suspensionPoints = wsMain.modules["wsapi3-search-local"].wsjsOptions["wsapi3-search-suspension-points"];

                        if (suggestions.length < 1 && products.length < 1) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.showResultsDiv(resultsDiv, "", "", "suggestionSearchError");
                            return;
                        }

                        if (suggestions.length < 1) suggestions.push({ search: query });

                        const mobileSuggestion = wsMain.modules["wsapi3-search-local"].wsjsOptions.mobileSuggestion;

                        const suggestionsHtml = suggestions
                            .map((item, idx) => {
                                if (mobileSuggestion) {
                                    if (idx < mobileSuggestion) {
                                        const position = item.search.indexOf(input.value);

                                        if (position == -1) {
                                            return `<a
                      href="/busca?s=${wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(item.search)}"
                      title="Sugestão de pesquisa"
                      class="wsapi3-search-suggestion"
                      onclick="wsMain.modules['wsapi3-search-local'].subfunctions.saveSearchTerm(this.value)"
                      wsapi3-search-suspension-points="${suspensionPoints}">
                      <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                        <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                      </svg>
                      <span>${item.search.trim()}</span>
                      </a>`;
                                        }

                                        const before = item.search.trim().slice(0, position);
                                        const after = item.search.trim().slice(position + input.value.length);

                                        return `<a
                    href="/busca?s=${wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(item.search)}"
                    title="Sugestão de pesquisa"
                    class="wsapi3-search-suggestion"
                    onclick="wsMain.modules['wsapi3-search-local'].subfunctions.saveSearchTerm(this.value)"
                    wsapi3-search-suspension-points="${suspensionPoints}">
                    <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                      <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                    </svg>
                    <span>${before ? `<strong>${before}</strong>` : ""}<span>${input.value}</span>${after ? `<strong>${after}</strong>` : ""}</span>
                    </a>`;
                                    }

                                    return "";
                                }

                                return `<a
                href="/busca?s=${wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(item.search)}"
                title="Sugestão de pesquisa"
                class="wsapi3-search-suggestion"
                onclick="wsMain.modules['wsapi3-search-local'].subfunctions.saveSearchTerm(this.value)"
                wsapi3-search-suspension-points="${suspensionPoints}">
                <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                </svg>
                <span>${item.search.trim()}</span>
                </a>`;
                            })
                            .join("");

                        if (suggestions[0].search) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.wordToViewAll = normalizedQuery.replace(/ /g, "-");
                        }

                        const limitToScroll = wsMain.modules["wsapi3-search-local"].wsjsOptions.limitToScroll;
                        const suggestionsScroll = suggestions.length > limitToScroll && !mobileSuggestion ? "on" : "off";

                        let productsToScroll = 2;
                        if (!sugestoesExist) productsToScroll = 3;

                        const productsHtml =
                            wsMain.modules["wsapi3-search-local"].subfunctions.displayProducts(products, productsToScroll) +
                            wsMain.modules["wsapi3-search-local"].subfunctions.viewAllResultsLink(
                                wsMain.modules["wsapi3-search-local"].subfunctions.wordToViewAll
                            );

                        wsMain.modules["wsapi3-search-local"].subfunctions.showResultsDiv(
                            resultsDiv,
                            `
              <div class="wsapi3-search-results-container">
                <div class="wsapi3-search-suggestions-container" wsapi3-search-suggestion-scroll="${suggestionsScroll}">
                  <div class="wsapi3-search-suggestions-options-container"  wsapi3-search-suggestion-scroll="${suggestionsScroll}">
                    <div class="wsapi3-search-suggestions-options">${sugestoesExist ? suggestionsHtml : ""}</div>
                  </div>
                </div>
                <div class="wsapi3-search-products-container">${produtosExist ? productsHtml : ""}</div>
              </div>
            `,
                            "",
                            "suggestionSearch"
                        );

                        if (produtosExist && normalizedQuery) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedProd.push({ [normalizedQuery]: productsHtml });
                            wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedWord = normalizedQuery;
                        }

                        wsMain.modules["wsapi3-search-local"].subfunctions.changeBgState("true");
                        wsMain.modules["wsapi3-search-local"].subfunctions.autocompleteInput(input, suggestions, resultsDiv);
                        wsMain.modules["wsapi3-search-local"].subfunctions.configureClickNavigation(input, resultsDiv);
                        wsMain.modules["wsapi3-search-local"].subfunctions.addHoverListenersToSuggestions(resultsDiv);
                        wsMain.modules["wsapi3-search-local"].subfunctions.actualFetchedSuggestions = suggestions;

                        resultsDiv.style.minHeight = "";
                    } catch (error) {
                        wsMain.modules["wsapi3-search-local"].subfunctions.showResultsDiv(
                            resultsDiv,
                            '<p class="wsapi3-search-searching-error">Erro ao buscar sugestões...</p>',
                            "",
                            "suggestionSearchError"
                        );
                        console.error("Erro:", error);
                    }
                },

                configureSearchEvents(input, resultsDiv) {
                    const debouncedFetchSuggestions = wsMain.modules["wsapi3-search-local"].subfunctions.debounce((query) => {
                        wsMain.modules["wsapi3-search-local"].subfunctions.fetchSuggestions(input, resultsDiv, query);
                    }, 600);

                    input.addEventListener("click", async () => {
                        const actualData = wsMain.modules["wsapi3-search-local"].subfunctions.actualData;
                        const actualInputWord = wsMain.modules["wsapi3-search-local"].subfunctions.actualInputWord;

                        if (input.value.length > 0 && actualData && actualInputWord.startsWith(input.value)) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.fetchSuggestions(input, resultsDiv, input.value, true);
                            wsMain.modules["wsapi3-search-local"].subfunctions.changeBgState("true");
                            return;
                        }

                        wsMain.modules["wsapi3-search-local"].subfunctions.displaySearchHistoryAndMostSearched(input, resultsDiv);
                        wsMain.modules["wsapi3-search-local"].subfunctions.changeBgState("true");
                    });

                    input.addEventListener("input", (e) => {
                        const query = e.target.value.trim();

                        // Só reaproveita as sugestões já na tela (atualizando o negrito) enquanto o
                        // que foi digitado ainda cabe dentro do termo da última busca (ex: digitando
                        // por cima do trecho autocompletado). Antes isso valia SEMPRE que existia
                        // sugestão renderizada — depois da 1ª busca nada mais era pesquisado.
                        const lastFetchedTerm = (wsMain.modules["wsapi3-search-local"].subfunctions.actualInputWord || "").toLowerCase();
                        const withinFetchedTerm = query.length > 0 && lastFetchedTerm.startsWith(query.toLowerCase());
                        if (withinFetchedTerm && wsMain.modules["wsapi3-search-local"].subfunctions.updateBoldInSugestions(input, resultsDiv)) return;

                        if (query.length >= 3) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.showLoading(resultsDiv, true);
                            debouncedFetchSuggestions(query);
                        } else if (query.length === 0) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.displaySearchHistoryAndMostSearched(input, resultsDiv);
                        }
                    });

                    input.addEventListener("keydown", (event) => {
                        if (event.key === "Enter" && input.value.trim()) {
                            wsMain.modules["wsapi3-search-local"].subfunctions.saveSearchTerm(input.value.trim());
                        }
                    });

                    if (window.innerWidth < 900) {
                        input.addEventListener("focusin", () => {
                            document.body.style.zoom = "1";
                        });
                        input.addEventListener("focusout", () => {
                            document.body.style.zoom = "";
                        });
                    }

                    const searchButton = document.querySelector("header .search-header button");
                    if (searchButton) {
                        searchButton.addEventListener("click", (event) => {
                            event.preventDefault();
                            wsMain.modules["wsapi3-search-local"].subfunctions.submitSearch(input);
                        });
                    }

                    if (window.visualViewport) {
                        const refit = () => wsMain.modules["wsapi3-search-local"].subfunctions.fitResultsToVisualViewport();
                        window.visualViewport.addEventListener("resize", refit);
                        window.visualViewport.addEventListener("scroll", refit);
                    }

                    const clearButton = document.querySelector(".wsapi3-search-clear-button");
                    if (clearButton) {
                        clearButton.addEventListener("click", () => {
                            wsMain.modules["wsapi3-search-local"].subfunctions.lastFetchedProd.length = 0;
                            input.value = "";
                            wsMain.modules["wsapi3-search-local"].subfunctions.changeBgState("false");
                            wsMain.modules["wsapi3-search-local"].subfunctions.hideResultsDiv(resultsDiv);
                        });
                    }

                    wsMain.modules["wsapi3-search-local"].subfunctions.configureKeyboardNavigation(input, resultsDiv);
                },

                updateBoldInSugestions(input, resultsDiv) {
                    try {
                        if (!input || !resultsDiv) return false;

                        const suggestionsElements = resultsDiv.querySelectorAll(
                            ".wsapi3-search-suggestions-options .wsapi3-search-suggestion > span"
                        );
                        if (suggestionsElements.length === 0) return false;

                        const actualFetchedSuggestions = wsMain.modules["wsapi3-search-local"].subfunctions.actualFetchedSuggestions;
                        const filteredSuggestions = actualFetchedSuggestions.map((sug) => sug.search.trim()).filter((word) => word);
                        if (!filteredSuggestions.length) return false;

                        const suggestionsDiv = resultsDiv.querySelector(
                            ".wsapi3-search-suggestions-container .wsapi3-search-suggestions-options"
                        );
                        suggestionsDiv.innerHTML = "";

                        const suspensionPoints = wsMain.modules["wsapi3-search-local"].wsjsOptions["wsapi3-search-suspension-points"];

                        filteredSuggestions.forEach((word) => {
                            const position = word.indexOf(input.value);
                            let formattedWord;

                            if (position == -1) {
                                formattedWord = `<a
                href="/busca?s=${wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(word)}"
                title="Sugestão de pesquisa"
                class="wsapi3-search-suggestion"
                onclick="wsMain.modules['wsapi3-search-local'].subfunctions.saveSearchTerm(this.value)"
                wsapi3-search-suspension-points="${suspensionPoints}">
                <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                  <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                </svg>
                <span>${word}</span>
                </a>`;
                            } else {
                                const before = word.slice(0, position);
                                const after = word.slice(position + input.value.length);

                                formattedWord = `<a
              href="/busca?s=${wsMain.modules["wsapi3-search-local"].subfunctions.normalizeQuery(word)}"
              title="Sugestão de pesquisa"
              class="wsapi3-search-suggestion"
              onclick="wsMain.modules['wsapi3-search-local'].subfunctions.saveSearchTerm(this.value)"
              wsapi3-search-suspension-points="${suspensionPoints}">
              <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
              </svg>
              <span>${before ? `<strong>${before}</strong>` : ""}<span>${input.value}</span>${after ? `<strong>${after}</strong>` : ""}</span>
              </a>`;
                            }

                            suggestionsDiv.innerHTML += formattedWord;
                        });

                        if (suggestionsDiv.getAttribute("autocomplete-inserted") === "true") return true;

                        wsMain.modules["wsapi3-search-local"].subfunctions.autocompleteInput(input, actualFetchedSuggestions, resultsDiv);
                        wsMain.modules["wsapi3-search-local"].subfunctions.configureClickNavigation(input, resultsDiv);
                        wsMain.modules["wsapi3-search-local"].subfunctions.addHoverListenersToSuggestions(resultsDiv);

                        return true;
                    } catch (error) {
                        console.log("[wsapi3-search-local] updateBoldInSugestions() | error:", error);
                        return false;
                    }
                },

                debounce(func, delay) {
                    let timerId;
                    return (...args) => {
                        clearTimeout(timerId);
                        timerId = setTimeout(() => func.apply(this, args), delay);
                    };
                },

                configureKeyboardNavigation(input, resultsDiv) {
                    input.addEventListener("keydown", (event) => {
                        const suggestions = resultsDiv.querySelectorAll(".wsapi3-search-suggestion");

                        // Enter precisa funcionar mesmo sem nenhuma sugestão renderizada.
                        if (event.key === "Enter") {
                            const currentIndex = wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex;
                            if (currentIndex >= 0 && suggestions[currentIndex]) {
                                input.value = suggestions[currentIndex].textContent;
                                wsMain.modules["wsapi3-search-local"].subfunctions.hideResultsDiv(resultsDiv);
                            }
                            wsMain.modules["wsapi3-search-local"].subfunctions.submitSearch(input);
                            return;
                        }

                        if (suggestions.length === 0) return;

                        if (event.key === "ArrowDown") {
                            event.preventDefault();
                            wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex =
                                (wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex + 1) % suggestions.length;
                            wsMain.modules["wsapi3-search-local"].subfunctions.updateSuggestionHighlight(
                                suggestions,
                                wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex,
                                input
                            );
                        } else if (event.key === "ArrowUp") {
                            event.preventDefault();
                            wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex =
                                (wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex - 1 + suggestions.length) % suggestions.length;
                            wsMain.modules["wsapi3-search-local"].subfunctions.updateSuggestionHighlight(
                                suggestions,
                                wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex,
                                input
                            );
                        }
                    });

                    document.addEventListener("click", (event) => {
                        if (
                            document.querySelector("#wsapi3-search-results").contains(event.target) ||
                            document.querySelector("#input-busca").contains(event.target)
                        ) {
                            return;
                        }

                        wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex = -1;
                        wsMain.modules["wsapi3-search-local"].subfunctions.changeBgState("false");
                        wsMain.modules["wsapi3-search-local"].subfunctions.hideResultsDiv(resultsDiv);
                    });

                    document.addEventListener("keydown", (event) => {
                        if (event.key == "Escape") {
                            input.blur();
                            wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex = -1;
                            wsMain.modules["wsapi3-search-local"].subfunctions.changeBgState("false");
                            wsMain.modules["wsapi3-search-local"].subfunctions.hideResultsDiv(resultsDiv);
                        }
                    });
                },

                configureClickNavigation(input, resultsDiv) {
                    const suggestions = resultsDiv.querySelectorAll(".wsapi3-search-suggestion");
                    suggestions.forEach((sug, idx) => {
                        sug.addEventListener("click", (e) => {
                            wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex = idx;
                            wsMain.modules["wsapi3-search-local"].subfunctions.updateSuggestionHighlight(
                                suggestions,
                                wsMain.modules["wsapi3-search-local"].subfunctions.currentIndex,
                                input
                            );
                            input.value = e.target.textContent;
                        });
                    });
                },

                updateSuggestionHighlight(suggestions, index, input) {
                    suggestions.forEach((item, i) => {
                        if (i === index) {
                            item.classList.add("wsapi3-search-active");
                            input.value = item.textContent.trim();
                        } else {
                            item.classList.remove("wsapi3-search-active");
                        }
                    });
                },

                createRecognitionBtn(searchInput) {
                    try {
                        const searchHeader = document.querySelector("header .search-header");
                        if (!searchHeader || !searchInput) return;

                        const recogBtn = document.querySelector(".wsapi3-search-mic-button");
                        if (!recogBtn) return;

                        const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
                        recognition.lang = "pt-BR";
                        recognition.continuous = false;
                        recognition.interimResults = false;

                        recogBtn.addEventListener("click", () => {
                            recognition.start();
                            recogBtn.classList.add("wsapi3-search-mic-listening");
                        });

                        recognition.onresult = (event) => {
                            searchInput.value = event.results[0][0].transcript.replace(".", "");
                            recogBtn.classList.remove("wsapi3-search-mic-listening");
                            searchInput.dispatchEvent(new Event("input", { bubbles: true }));
                        };

                        recognition.onerror = () => {
                            recogBtn.classList.remove("wsapi3-search-mic-listening");
                        };
                    } catch (error) { }
                },

                changeBgState(state) {
                    const bgOption = wsMain.modules["wsapi3-search-local"].wsjsOptions.blur;
                    if (!bgOption) return;

                    // Só entra em "true" se o painel de resultados estiver mesmo visível —
                    // evita esfumaçar o fundo quando o clique no input não rendeu nada (ex:
                    // sem histórico e sem mais buscados). "false" é sempre idempotente.
                    if (state === "true") {
                        const resultsDiv = document.querySelector("#wsapi3-search-results");
                        if (!resultsDiv || resultsDiv.style.display !== "flex") return;
                    }

                    document.querySelector("#wsapi3-search-bg").setAttribute("wsapi3-search-bg-active", state);
                    document.querySelector("body").style.overflow = state == "true" ? "hidden" : "";
                },

                addZindexInput() {
                    const inputBusca = document.getElementById("input-busca");
                    if (!inputBusca) return;

                    const divPai = inputBusca.parentElement;
                    if (divPai) {
                        divPai.style.zIndex = "3";
                        divPai.style.position = "relative";
                    }
                },

                getScrollbarWidth() {
                    const outer = document.createElement("div");
                    outer.style.visibility = "hidden";
                    outer.style.overflow = "scroll";
                    outer.style.msOverflowStyle = "scrollbar";
                    document.body.appendChild(outer);

                    const inner = document.createElement("div");
                    outer.appendChild(inner);

                    const width = outer.offsetWidth - inner.offsetWidth;
                    outer.parentNode.removeChild(outer);
                    return width;
                },

                positionCloseBtn() {
                    try {
                        const input = document.getElementById("input-busca");
                        const results = document.getElementById("wsapi3-search-results");
                        const clearButton = document.querySelector("#wsapi3-search-clear-button");
                        if (!input || !results || !clearButton) return;

                        clearButton.style.display = "flex";

                        const scrollbarWidth = wsMain.modules["wsapi3-search-local"].subfunctions.getScrollbarWidth();
                        const rect = input.getBoundingClientRect();
                        const pageWidth = window.innerWidth;
                        let distanceFromTop = rect.bottom;

                        if (window.innerWidth < 576) {
                            results.style.minWidth = input.offsetWidth / 10 + "rem";
                        }

                        if (document.querySelector("header").style.position == "fixed") {
                            results.style.position = "fixed";
                        } else {
                            results.style.position = "absolute";
                        }

                        results.style.top = `${distanceFromTop / 10 + 2}rem`;
                        results.style.width = input.offsetWidth / 10 + "rem";
                        results.style.left = rect.left / 10 + "rem";

                        if (window.innerWidth < 1200) {
                            results.style.top = `${distanceFromTop + 20}px`;
                        }

                        if (pageWidth - rect.right + 700 + scrollbarWidth < 1100) {
                            results.style.right = (pageWidth - rect.right - scrollbarWidth) / 10 + "rem";
                            results.style.left = "initial";
                        }

                        let clearButtonRight = (rect.width - 35) / 10;
                        clearButton.style.left = `${clearButtonRight}rem`;

                        const searchBtn = document.querySelector("header .search-header button");
                        const micButton = document.querySelector("header .search-header .wsapi3-search-mic-button");

                        const rect1 = clearButton.getBoundingClientRect();
                        const rect2 = searchBtn.getBoundingClientRect();

                        let rect3 = "";
                        if (micButton) rect3 = micButton.getBoundingClientRect();

                        clearButton.style.display = "none";

                        const horizontalTouchSearchBtn = rect1.right >= rect2.left && rect1.left <= rect2.right;
                        const verticalTouchSearchBtn = rect1.bottom >= rect2.top && rect1.top <= rect2.bottom;

                        let horizontalTouchMicBtn = "";
                        let verticalTouchMicBtn = "";

                        if (rect3) {
                            horizontalTouchMicBtn = rect1.right >= rect3.left && rect1.left <= rect3.right;
                            verticalTouchMicBtn = rect1.bottom >= rect3.top && rect1.top <= rect3.bottom;
                        }

                        if ((horizontalTouchSearchBtn && verticalTouchSearchBtn) || (horizontalTouchMicBtn && verticalTouchMicBtn)) {
                            clearButtonRight = (rect.width - 70) / 10;
                            input.style.paddingRight = "7.5rem";
                            clearButton.style.left = `${clearButtonRight}rem`;
                        } else {
                            input.style.paddingRight = "4.5rem";
                        }
                    } catch (error) { }
                },

                positionMic() {
                    try {
                        const input = document.getElementById("input-busca");
                        const micButton = document.querySelector(".search-header .wsapi3-search-mic-button");
                        if (!micButton || !input) return;

                        const inputRect = input.getBoundingClientRect();
                        const searchBtn = document.querySelector("header .search-header button");
                        const micRect = micButton.getBoundingClientRect();
                        const searchBtnRect = searchBtn.getBoundingClientRect();

                        const horizontalTouch = micRect.right >= searchBtnRect.left && micRect.left <= searchBtnRect.right;
                        const verticalTouch = micRect.bottom >= searchBtnRect.top && micRect.top <= searchBtnRect.bottom;

                        if (horizontalTouch && verticalTouch) {
                            micButton.style.left = (inputRect.width - 35) / 10 + "rem";
                        } else {
                            input.style.paddingLeft = "4rem";
                        }
                    } catch (error) { }
                },

                updateOptions(options) {
                    try {
                        const keys = Object.keys(options);
                        if (!keys.length) return;

                        keys.forEach((key) => {
                            if (key in wsMain.modules["wsapi3-search-local"].wsjsOptions) {
                                wsMain.modules["wsapi3-search-local"].wsjsOptions[key] = options[key];
                            }
                        });
                    } catch (error) { }
                },

                updateOptionsByInfoLojas() {
                    try {
                        const buscaConfig = wsMain?.globalData?.infoLoja?.busca;
                        if (!buscaConfig) return;

                        const buscaOptionsKeys = Object.keys(buscaConfig);
                        if (!buscaOptionsKeys.length) return;

                        buscaOptionsKeys.forEach((key) => {
                            const value = buscaConfig[key];
                            if (key in wsMain.modules["wsapi3-search-local"].wsjsOptions && value !== undefined && value !== "") {
                                if (key === "mais_buscados") {
                                    wsMain.modules["wsapi3-search-local"].wsjsOptions[key] = value.filter((item) => item);
                                    return;
                                }
                                wsMain.modules["wsapi3-search-local"].wsjsOptions[key] = value;
                            }
                        });
                    } catch (error) { }
                },

                // Seta a mesma CSS var que wsapi3-apps.css lê em .wsapi3-search-prods-title
                // (--wsapi3-search-prods-title-line-clamp) — no app nativo esses dois nomes
                // divergiam (ver header do módulo acima), aqui nascem consistentes.
                prodsTitleMaxLines() {
                    const limit = wsMain.modules["wsapi3-search-local"].wsjsOptions.prodsTitleLimits;
                    if (limit < 0) return;
                    document.documentElement.style.setProperty("--wsapi3-search-prods-title-line-clamp", limit);
                },

                getStoreId() {
                    const storeIdInput = document.querySelector("#HD_LV_ID");
                    if (storeIdInput) wsMain.modules["wsapi3-search-local"].subfunctions.storeID = storeIdInput.value;
                },

                updateLocalstorageByQueryParam() {
                    const params = new URLSearchParams(window.location.search);
                    if (params.has("s")) {
                        wsMain.modules["wsapi3-search-local"].subfunctions.saveSearchTerm(params.get("s"));
                    }
                },

                defaultMobileSettings() {
                    if (window.innerWidth <= 800) {
                        wsMain.modules["wsapi3-search-local"].wsjsOptions.mobileSuggestion = 3;
                    }
                },

                createDynamicAnchor() {
                    const searchHeader = document.querySelector("header .search-header");
                    if (!searchHeader) return;

                    if (!document.querySelector("header #wsapi3-search-clear-button")) {
                        const clearButton = document.createElement("span");
                        clearButton.id = "wsapi3-search-clear-button";
                        clearButton.classList.add("wsapi3-search-clear-button");
                        clearButton.style.display = "none";
                        clearButton.innerHTML = "&#10005;";
                        searchHeader.appendChild(clearButton);
                    }

                    if (!document.querySelector(".wsapi3-search-mic-button") && wsMain.modules["wsapi3-search-local"].wsjsOptions.busca_com_voz) {
                        const micButton = document.createElement("span");
                        micButton.classList.add("wsapi3-search-mic-button");
                        micButton.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-40 520v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80Zm40-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480Z"/></svg>
              `;
                        searchHeader.appendChild(micButton);
                    }

                    // Fundo esfumaçado atrás dos resultados desligado por padrão (blur: false,
                    // desktop e mobile) — o DIV só é criado se a opção for religada.
                    if (wsMain.modules["wsapi3-search-local"].wsjsOptions.blur && !document.querySelector("header #wsapi3-search-bg")) {
                        const headerTopContainer = document.querySelector("header .header-top .container");
                        if (headerTopContainer) {
                            const bg = document.createElement("div");
                            bg.setAttribute("wsapi3-search-bg-active", "false");
                            bg.id = "wsapi3-search-bg";
                            headerTopContainer.appendChild(bg);
                        }
                    }
                },

                initializeSearch() {
                    wsMain.modules["wsapi3-search-local"].subfunctions.updateOptionsByInfoLojas();
                    wsMain.modules["wsapi3-search-local"].subfunctions.createDynamicAnchor();

                    const input = document.getElementById("input-busca");
                    const clearButton = document.getElementById("wsapi3-search-clear-button");

                    wsMain.modules["wsapi3-search-local"].subfunctions.updateLocalstorageByQueryParam();

                    const resultsDiv = wsMain.modules["wsapi3-search-local"].subfunctions.createResultsDiv();
                    const wsOptions = wsMain.tools.getWsData(input, "options");
                    wsMain.modules["wsapi3-search-local"].subfunctions.updateOptions(wsOptions);
                    wsMain.modules["wsapi3-search-local"].subfunctions.createRecognitionBtn(input);
                    wsMain.modules["wsapi3-search-local"].subfunctions.addZindexInput();
                    wsMain.modules["wsapi3-search-local"].subfunctions.positionMic();
                    wsMain.modules["wsapi3-search-local"].subfunctions.positionCloseBtn();
                    wsMain.modules["wsapi3-search-local"].subfunctions.getStoreId();
                    wsMain.modules["wsapi3-search-local"].subfunctions.defaultMobileSettings();
                    wsMain.modules["wsapi3-search-local"].subfunctions.prodsTitleMaxLines();
                    wsMain.modules["wsapi3-search-local"].subfunctions.configureClearButton(input, clearButton);
                    wsMain.modules["wsapi3-search-local"].subfunctions.configureSearchEvents(input, resultsDiv);
                },
            },

            async get() {
                try {
                    if (wsMain.__advancedSearchLocalStarted) return;

                    if (!wsMain?.globalData?.infoLoja) {
                        setTimeout(() => wsMain.modules["wsapi3-search-local"].get(), 1000);
                        return;
                    }

                    wsMain.__advancedSearchLocalStarted = true;
                    wsMain.modules["wsapi3-search-local"].subfunctions.initializeSearch();
                    return true;
                } catch (error) {
                    console.log("[wsapi3-search-local] get() | error:", error);
                    return false;
                }
            },
        });

        wsMain.modules["wsapi3-search-local"].get();
    } catch (error) {
        console.log(`[wsapi3-search-local] falha ao inicializar: ${error.message}`);
    }
}, 2000);
